/**
 * Eventos de conversión para los píxeles que carga MarketingPixels (Meta y
 * TikTok). Solo en el navegador; sin pixel cargado no hace nada. Es lo que
 * permite pasar las campañas de «tráfico» a «clientes potenciales» cuando el
 * pixel acumule envíos (README de cada puerta en docs/marketing/mr-marketing/ads).
 */
type PixelWindow = Window & {
  fbq?: (...args: unknown[]) => void
  ttq?: { track?: (event: string, params?: Record<string, unknown>) => void }
}

export function trackLead(params: { content_name: string; content_category?: string }): void {
  if (typeof window === "undefined") return
  const w = window as PixelWindow
  try {
    if (typeof w.fbq === "function") w.fbq("track", "Lead", params)
    if (w.ttq?.track) w.ttq.track("SubmitForm", { content_name: params.content_name })
  } catch {
    // Un pixel roto nunca rompe el formulario.
  }
}
